import { render } from "./InformationRow.vue?vue&type=template&id=6a7be6b6&scoped=true"
import script from "./InformationRow.vue?vue&type=script&lang=js"
export * from "./InformationRow.vue?vue&type=script&lang=js"

import "./InformationRow.vue?vue&type=style&index=0&id=6a7be6b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7be6b6"]])

export default __exports__